import React from 'react';
import { STATUS_DEFS, TOTAL_COLOR } from '../statusMeta';
import { useTheme } from '../../../theme/ThemeProvider';
import styles from './LoadsStatusCards.module.css';

interface LoadsStatusCardsProps {
  counts: Record<string, number>;
  /** Keys de status seleccionados (def.key). Vacío = Total (todos). */
  selected: string[];
  onToggle: (key: string) => void;
  onClear: () => void;
  /** Cambia cada vez que se aplican filtros: re-dispara la animación. */
  pulseKey?: number;
  /** true = los conteos reflejan filtros activos (no el total del sistema). */
  filtered?: boolean;
}

const LoadsStatusCards: React.FC<LoadsStatusCardsProps> = ({
  counts,
  selected,
  onToggle,
  onClear,
  pulseKey = 0,
  filtered = false,
}) => {
  const { resolvedTheme } = useTheme();
  const total = STATUS_DEFS.reduce((sum, def) => sum + (counts[def.key] || 0), 0);

  const cards = [
    { key: 'Total', label: 'Total', color: TOTAL_COLOR, count: total, total: true },
    ...STATUS_DEFS.map((def) => ({
      key: def.key,
      label: def.label,
      color: def.color,
      count: counts[def.key] || 0,
      total: false,
    })),
  ];

  return (
    <div
      className={[styles.row, filtered ? styles.rowFiltered : ''].join(' ')}
      title={filtered ? 'Counts reflect the active filters' : undefined}
    >
      {cards.map((c, i) => {
        const active = c.total ? selected.length === 0 : selected.includes(c.key);
        // El número de Total en dark no se distingue con su gris → blanco
        const countColor =
          c.total && resolvedTheme === 'dark' ? '#ffffff' : c.color;
        const empty = !c.total && c.count === 0;
        return (
          <button
            key={c.key}
            type="button"
            className={[
              styles.card,
              active ? styles.active : '',
              empty ? styles.cardEmpty : '',
            ]
              .filter(Boolean)
              .join(' ')}
            style={{ ['--card-color' as any]: c.color }}
            onClick={() => (c.total ? onClear() : onToggle(c.key))}
            title={c.total ? 'Show all' : `Filter by ${c.label}`}
          >
            <span className={styles.pill} style={{ background: c.color }}>
              {c.label}
            </span>
            {/*
              key incluye pulseKey y el valor: al aplicar filtros el nodo se
              remonta y la animación vuelve a correr, haciendo evidente el cambio.
            */}
            <span
              key={`${pulseKey}-${c.count}`}
              className={styles.count}
              style={{ color: countColor, animationDelay: `${i * 45}ms` }}
            >
              {c.count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default LoadsStatusCards;
